// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"fc8071cc","232":"033fcc65","237":"9f12dd63","526":"e2c7cab9","787":"61842c5f"}[chunkId] + ".chunk.js";
};